export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Profile',
        route: 'profile',
        icon: 'UserIcon',
      },
      {
        title: 'Documents',
        route: 'documents',
        icon: 'FileIcon',
      },
    ],
  },
]
